"use client";

import * as React from "react";
import * as CollapsiblePrimitive from "@radix-ui/react-collapsible";

import { cn } from "@/lib/utils";

const Collapsible = CollapsiblePrimitive.Root;
const CollapsibleTrigger = CollapsiblePrimitive.CollapsibleTrigger;

/**
 * Radix's CollapsibleContent has no animation of its own — this file used to
 * re-export it bare, so every collapsible in the portal (the sidebar "Más"
 * group, the invoice sections, the accountant panels) snapped open and shut
 * with no transition at all.
 *
 * Height cannot be animated from `auto`, which is why this needs keyframes
 * rather than a transition: Radix measures the panel and publishes
 * `--radix-collapsible-content-height`, and the keyframes interpolate to that.
 * `overflow: hidden` is required or the content spills during the animation.
 *
 * Consumers can still pass className; theirs is merged after, so a caller can
 * override padding or add its own classes without losing the animation.
 */
const CollapsibleContent = React.forwardRef<
  React.ElementRef<typeof CollapsiblePrimitive.CollapsibleContent>,
  React.ComponentPropsWithoutRef<typeof CollapsiblePrimitive.CollapsibleContent>
>(({ className, ...props }, ref) => (
  <CollapsiblePrimitive.CollapsibleContent
    ref={ref}
    className={cn("fx-collapsible-content", className)}
    {...props}
  />
));
CollapsibleContent.displayName =
  CollapsiblePrimitive.CollapsibleContent.displayName;

export { Collapsible, CollapsibleTrigger, CollapsibleContent };
